import { render } from "./ItemDisplay.vue?vue&type=template&id=61e62a27&scoped=true"
import script from "./ItemDisplay.vue?vue&type=script&lang=js"
export * from "./ItemDisplay.vue?vue&type=script&lang=js"

import "./ItemDisplay.vue?vue&type=style&index=0&id=61e62a27&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e62a27"]])

export default __exports__